const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    noticeBar: {
      border: 'none',
      background: 'transparent',
      '--height': '54px',
    },
    carouselContainer: {
      display: 'flex',
      width: '100%',
      height: '100%',
    },
    individualContainer: {
      background: 'radial-gradient(#1C69A6, #011527)',
      borderRadius: '3px',
      margin: [0, 5],
      padding: [0, 5],
      display: 'flex',
      alignItems: 'center',
    },
    playerBorder: {
      marginRight: 5,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
